import { Action } from 'redux';

export function reduceReducers<S>(...reducers: Array<(state: S | undefined, action: Action) => S>) {
  return (state: S | undefined, action: Action): S =>
    reducers.reduce((acc, reducer) => reducer(acc, action), state ?? {} as S);
}